export default {"src":"/_next/static/media/sadness.3d5d9ae0.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};